// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Mauritania from '../_raw/flag/icon_flag_mauritania.png';

export default () => <img src={Mauritania} alt="Mauritania" />;
